import api from './api';
import types from './mutation-types';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchPopupStateInit_({ commit }) {
		commit(types.SEARCH_POPUP_STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setStateParam_({ commit }, { key, value }) {
		commit(types.STATE_PARAM, { key, value });
	},
	setSelectedRow_({ commit }, { key, value }) {
		commit(types.SELECTED_ROW, { key, value });
	},
	setGridRowInit_({ commit }) {
		commit(types.GRID_ROW_INIT);
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setReInsPopupParams_({ commit }, { key, value }) {
		commit(types.RE_INS_POPUP_PARAMS, { key, value });
	},
	/**call API */
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce_({ commit }) {
		try {
			function sortCommCdList(commCd, val) {
				const key = _.camelCase(commCd) + 'CdList';
				commit(types.DEFAULT_ASSIGN, { key, value: val });
			}
			const { header, body } = await api.getCommCodesOnce();
			if (header.code === 0) {
				for (const [key, val] of Object.entries(body)) {
					sortCommCdList(key, val);
				}
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error?.header;
		}
	},
	async getList_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getList({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit });
			if (data.header.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header || error);
		}
	},
	async updateUnit_({ state }) {
		const { overSrgNo, occuQty, badSbc } = state.selectedRow;
		const updatedRow = { overSrgNo, occuQty, badSbc };
		try {
			const { header } = await api.updateUnit(updatedRow);
			return header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},
	// 조회버튼 클릭시
	async getPartCkuInfo_({ commit, state }, searchParams) {
		try {
			const data = await api.getPartCkuInfo({ searchParams });
			if (data.header.code === 0) {
				// const { result,  } = data.body;
				const { partCkuInfo, dtlList, jgmtReslutList } = data.body;
				await commit(types.DEFAULT_ASSIGN, { key: 'formInfo', value: partCkuInfo === null ? [] : partCkuInfo });
				await commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: dtlList === null ? [] : dtlList });
				await commit(types.DEFAULT_ASSIGN, { key: 'jgmtReslutList', value: jgmtReslutList === null ? [] : jgmtReslutList });
				// resultList.forEach(row => delete row.totalSize);
				// commit(types.SET, { key: 'masterList', value: resultList });
				// commit(types.SET, { key: 'masterPagingInfo', value: pagingInfo });
				// commit(types.SET, { key: 'detailList', value: [] });
				// commit(types.SET, { key: 'currentMsterValue', value: '' });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			//return error.header || error;
			throw new Error(error.header.message || error);
		}

		// return api
		// .getPartCkuMstList({ ...state.searchParams, ...pagingInfo })
		// .then(({ body: { resultList, pagingInfo }, header }) => {
		// 	resultList.forEach(row => delete row.totalSize);
		// 	commit(types.SET, { key: 'masterList', value: resultList });
		// 	commit(types.SET, { key: 'masterPagingInfo', value: pagingInfo });
		// 	commit(types.SET, { key: 'detailList', value: [] });
		// 	commit(types.SET, { key: 'currentMsterValue', value: '' });
		// 	return resultList;
		// })
		// .catch(e => console.error(e));
	},

	// 조회버튼 클릭시
	async getSearchBarcodeData_({ commit, state }, barCodeParams) {
		try {
			const data = await api.getSearchBarcodeData({ barCodeParams });
			//console.log('getSearchBarcodeData_ >>> ', data);
			if (data.header.code === 0) {
				// const { result,  } = data.body;

				const { partNo, ckuNo, lotFromNo, lotToNo, cofCd, cofNm, resultYn, partCkuInfo, dtlList, jgmtReslutList } = data.body;
				await commit(types.DEFAULT_ASSIGN, { key: 'formInfo', value: partCkuInfo === null ? [] : partCkuInfo });
				await commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: dtlList === null ? [] : dtlList });
				await commit(types.DEFAULT_ASSIGN, { key: 'jgmtReslutList', value: jgmtReslutList === null ? [] : jgmtReslutList });

				if ((partCkuInfo !== null || partCkuInfo !== undefined) && partCkuInfo.ckuNo !== '') {
					await commit(types.SEARCH_PARAM, { key: 'partNo', value: partCkuInfo.partNo });
					await commit(types.SEARCH_PARAM, { key: 'ckuNo', value: partCkuInfo.ckuNo });
				}
				// await commit(types.SEARCH_BARCODE_RESULT, { key: 'partNo', value: partNo });
				// await commit(types.SEARCH_BARCODE_RESULT, { key: 'ckuNo', value: ckuNo });
				// await commit(types.SEARCH_BARCODE_RESULT, { key: 'lotFromNo', value: lotFromNo });
				// await commit(types.SEARCH_BARCODE_RESULT, { key: 'lotToNo', value: lotToNo });
				// await commit(types.SEARCH_BARCODE_RESULT, { key: 'lotToNo', value: lotToNo });
				// await commit(types.SEARCH_BARCODE_RESULT, { key: 'cofCd', value: cofCd });
				// await commit(types.SEARCH_BARCODE_RESULT, { key: 'cofNm', value: cofNm });
				await commit(types.SEARCH_BARCODE_RESULT, { key: 'resultYn', value: resultYn });
			}
			//  else if (data.header.code === 3) {
			// 	console.log('getSearchBarcodeData_ >>> ', data.header.messageCd);
			// 	this.$sf_toast({ type: 'error', message: data.header.messageCd });
			// }
			return data.header;
		} catch (error) {
			//return error.header || error;
			throw new Error(error.header.message || error);
		}
	},
	/** 바코드 조회 완료시 하단 영역 초기화 */
	setBarcodeSearchInit_({ commit }) {
		commit(types.BARCODE_SEARCH_INIT);
	},
	//form영역에서 입력한 항목을 formInfo store에 세팅
	onChangeParam_({ commit }, payload) {
		commit(types.SET_FORM, payload);
	},

	// 저장버튼 클릭시
	async savePartCku_(store, { partNo, list, form }) {
		try {
			const { header } = await api.savePartCku({ partNo, list, form });
			return header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},

	// 저장버튼 클릭시
	async savePartCku2_({ commit }, formData) {
		try {
			const { header } = await api.savePartCku2(formData);
			return header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},

	// 승인프로세스 로직
	async saveState_({ commit }, stateParams) {
		try {
			const { header } = await api.saveState(stateParams);
			return header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},

	// 재검사버튼 클릭시
	// async saveReInsp_({ commit }, formData) {
	// 	try {
	// 		const { header } = await api.saveReInsp(formData);
	// 		return header;
	// 	} catch (error) {
	// 		return error.header || error;
	// 	}
	// },
	async saveReInspPopup_({ commit }, reInsPopupParams) {
		try {
			const data = await api.saveReInspPopup(reInsPopupParams);
			return data;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},

	// 종합판정 변경시 DB저장
	async saveChangeJgmtCd_({ commit }, params) {
		try {
			const { header } = await api.saveChangeJgmtCd(params);
			return header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	async getPartPopupResults_({ commit, state }, searchDtlParams) {
		try {
			const { pagingInfo } = state;
			const data = await api.getPartPopupResults({
				searchDtlParams,
				currentPage: pagingInfo.currentPage,
				pageUnit: pagingInfo.pageUnit
			});
			if (data.header.code === 0) {
				const { pagingInfo, resultPopupList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'resultPopupList', value: resultPopupList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},
	// 엑셀템플릿 다운
	async excelTempDown_(store, params) {
		try {
			const response = await api.excelTempDown(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			// return error?.header;
			throw new Error(error?.header);
		}
	},
	setSearchPopupCommInit_({ commit }) {
		commit(types.SEARCH_POPUP_COMM_INIT);
	},
	async getPartPopupCommResults_({ commit }, searchCommParams) {
		try {
			const data = await api.getPartPopupCommResults({
				searchCommParams
			});
			if (data.header.code === 0) {
				//console.log('data.body >>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', data.body);
				const { resultPopupCommList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'resultPopupCommList', value: resultPopupCommList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},
	// 첨부파일 다운로드
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			throw error.header || error;
		}
	}
};
